/*
 * Paragon Timeline
 * Scroll-triggered reveal: as each milestone enters the viewport, its spine
 * segment "draws" downward to connect the next dot, the diamond node pops in,
 * and the text + image fade up. Progressive enhancement only — without JS (or
 * with reduced-motion) every milestone renders fully visible.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function initTimeline(timeline) {
    if (timeline.dataset.tlInit === 'true') return;
    timeline.dataset.tlInit = 'true';
    timeline.classList.add('paragon-timeline--animate');

    var items = timeline.querySelectorAll('.paragon-timeline__item');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll('.paragon-timeline').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.paragon-timeline').forEach(initTimeline);
  });
})();
